var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAttrHealthCheckup(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28.8984 35.2969H7.10156C5.93662 35.2969 4.99219 34.3524 4.99219 33.1875V2.8125C4.99219 1.64756 5.93662 0.703125 7.10156 0.703125H28.8984C30.0634 0.703125 31.0078 1.64756 31.0078 2.8125V33.1875C31.0078 34.3524 30.0634 35.2969 28.8984 35.2969Z",
    stroke: "#2B195B",
    strokeWidth: 1.25,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M23.2734 3.51562H23.218C23.0067 4.40262 22.2095 5.0625 21.2578 5.0625H14.7421C13.7904 5.0625 12.9933 4.40262 12.7819 3.51562H12.7266H7.80469V32.4844H28.1953V3.51562H23.2734Z",
    fill: "#EAE8EF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M21.8672 11.0391H19.4062V8.57812H16.5938V11.0391H14.1328V13.8516H16.5938V16.3125H19.4062V13.8516H21.8672V11.0391Z",
    stroke: "#2B195B",
    strokeWidth: 1.25,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M15.5391 19.8281H11.3203V22.6406H15.5391V19.8281Z",
    stroke: "#2B195B",
    strokeWidth: 1.25,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M19.0547 22.6406H24.6797",
    stroke: "#2B195B",
    strokeWidth: 1.25,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M19.0547 19.8281H24.6797",
    stroke: "#2B195B",
    strokeWidth: 1.25,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M15.5391 26.1562H11.3203V28.9688H15.5391V26.1562Z",
    stroke: "#2B195B",
    strokeWidth: 1.25,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M19.0547 28.9688H24.6797",
    stroke: "#2B195B",
    strokeWidth: 1.25,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M19.0547 26.1562H24.6797",
    stroke: "#2B195B",
    strokeWidth: 1.25,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M21.2578 5.0625H14.7421C13.629 5.0625 12.7266 4.16011 12.7266 3.04692V0.703125H23.2734V3.04692C23.2734 4.16011 22.371 5.0625 21.2578 5.0625Z",
    stroke: "#2B195B",
    strokeWidth: 1.25,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAttrHealthCheckup);
export default __webpack_public_path__ + "static/media/attr_health_checkup.b18ef60d63a821b5ba1e1fc44cf1b6ce.svg";
export { ForwardRef as ReactComponent };